import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Select from '../ui/Select';
import AnnouncementService from '../../services/AnnouncementService';

const Header = () => {
    const [currentIncident, setCurrentIncident] = useState('');
    const [closedIncident, setClosedIncident] = useState('');
    const [activeIncidents, setActiveIncidents] = useState([]);
    const [drills, setDrills] = useState([]);

    const navigate = useNavigate();

    useEffect(() => {
        const load = async () => {
            try {
                const response = await AnnouncementService.findAll(1, 100);
                if (response && response.status === 200) {
                    setActiveIncidents(response.data.filter(a => !a.drill));
                    setDrills(response.data.filter(a => a.drill));
                }
            } catch (error) {
                console.log(error);
            }
        };
        load();
    }, []);

    const handleCurrentChange = (event) => {
        setCurrentIncident(event.target.value);
        navigate(`/active-incident/${event.target.value}`);
    };

    const handleClosedChange = (event) => {
        setClosedIncident(event.target.value);
        navigate(`/closed-incident/${event.target.value}`);
    };

    return (
        <div className="hidden md:flex items-center gap-2.5">
            <Select
                className="!py-2 w-44 text-xs"
                value={currentIncident}
                onChange={handleCurrentChange}
            >
                <option value="" disabled>Active Incidents</option>
                {activeIncidents.map(incident => (
                    <option key={incident.id} value={incident.id}>{incident.title}</option>
                ))}
            </Select>

            <Select
                className="!py-2 w-40 text-xs"
                value={closedIncident}
                onChange={handleClosedChange}
            >
                <option value="" disabled>Drills</option>
                {drills.map(drill => (
                    <option key={drill.id} value={drill.id}>{drill.title}</option>
                ))}
            </Select>
        </div>
    );
};

export default Header;
